import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import {FlexModule} from "@angular/flex-layout";
import {MatButtonModule} from "@angular/material/button";
import {MatCardModule} from "@angular/material/card";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule, MatMenuTrigger} from "@angular/material/menu";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatTabsModule} from "@angular/material/tabs";
import {PerfectScrollbarModule} from "ngx-perfect-scrollbar";
import {PipesModule} from "../../theme/pipes/pipes.module";
import {NotificationBellService} from "./notification-bell.service";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {NotificationService} from "./notification.service";

@Component({
  selector: 'app-notification-bell',
  standalone: true,
  imports: [CommonModule, FlexModule, MatButtonModule, MatCardModule, MatIconModule, MatMenuModule, MatProgressBarModule, MatTabsModule, PerfectScrollbarModule, PipesModule, TranslateModule],
  providers:[NotificationBellService, NotificationService],
  templateUrl: './notification-bell.component.html',
  styleUrls: ['./notification-bell.component.scss']
})
export class NotificationBellComponent implements OnInit {

  @Input() isOpen = false; // Input to control visibility
  @Output() closeSidebar = new EventEmitter<void>(); // Output to notify parent

  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  public selectedTab:number=1;
  public messages:Array<Object>;
  public files:Array<Object>;
  public meetings:Array<Object>;
  constructor(public messagesService:NotificationBellService, public translate: TranslateService, private notificationService: NotificationService ) {
    this.notificationService.connect();
  }


  close() {
    this.isOpen = false;
  }

  ngOnInit() {

  }

  toggleSidebar() {
    this.isOpen = !this.isOpen;
  }

  openMessagesMenu() {
    this.trigger.openMenu();
    this.selectedTab = 0;
  }

  onMouseLeave(){
    this.trigger.closeMenu();
  }

  stopClickPropagate(event: any){
    event.stopPropagation();
    event.preventDefault();
  }

}
